import { Component } from "@angular/core";

@Component({
    selector: "ng-app-list",
    template: `
        <div class="app-list-body">
            <ng-app-listing></ng-app-listing>
        </div>
        <router-outlet></router-outlet>
    `,
    styleUrls: ["./ng-app-list.component.less"]
})
export class NgAppListComponent { }
